export const MAX_CHARS = 1000; // Used in Input component
export const CHANNEL_EXPIRY_TIME_5MINS = 1000 * 60 * 5; // 5mins
export const CHANNEL_EXPIRY_TIME_24HRS = 1000 * 60 * 60 * 24; // 24 Hrs
